import { Injectable } from '@angular/core'
import Swal from 'sweetalert2'

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  notifyError (message: string): void {
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: message,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#E95A1A'
    })
  }

  showSuccessAlertAndAction (msg: string, ejecutar: any) {
    Swal.fire({
      title: 'Éxito',
      text: msg,
      icon: 'success',
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Aceptar'
    }).then(result => {
      if (result.isConfirmed) {
        ejecutar()
      }
    })
  }

  showSuccessAlertAndDoubleAction (msg: string, ejecutar: any, cancelar?: any) {
    Swal.fire({
      title: 'Éxito',
      text: msg,
      icon: 'success',
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar'
    }).then(result => {
      if (result.isConfirmed) {
        ejecutar()
      } else if (result.dismiss === Swal.DismissReason.cancel && cancelar) {
        cancelar()
      }
    })
  }

  showSuccessAlert (msg: string, ejecutar?: any) {
    if (ejecutar) {
      Swal.fire({
        title: 'Éxito',
        text: msg,
        icon: 'success',
        showConfirmButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Aceptar'
      }).then(() => {
        ejecutar()
      })
    } else {
      Swal.fire({
        title: 'Éxito',
        text: msg,
        icon: 'success',
        showConfirmButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Aceptar'
      })
    }
  }

  notifyWarning (message: string) {
    Swal.fire({
      icon: 'warning',
      title: 'Advertencia',
      text: message,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#E95A1A'
    })
  }
}
